import React, { useState, useEffect, useCallback } from 'react';
import { fetchBrokerReviews } from '../lib/brokerReviews';
import StarRating from './StarRating';
import './ReviewsList.css';

const PAGE_SIZE = 5;

const IcFlag = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/>
    <line x1="4" y1="22" x2="4" y2="15"/>
  </svg>
);

const IcReply = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 17 4 12 9 7"/>
    <path d="M20 18v-2a4 4 0 0 0-4-4H4"/>
  </svg>
);


function formatDate(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

function ReviewCard({ review }) {
  const reviewer = review.reviewer;
  const name = reviewer?.full_name || 'Anonymous User';
  const initials = name.split(' ').map((w) => w[0]).join('').slice(0, 2).toUpperCase();

  return (
    <div className="rvl__card">
      <div className="rvl__card-header">
        <div className="rvl__avatar">
          {reviewer?.avatar_url ? (
            <img src={reviewer.avatar_url} alt={name} className="rvl__avatar-img" />
          ) : (
            <span className="rvl__avatar-initials">{initials}</span>
          )}
        </div>
        <div className="rvl__card-meta">
          <span className="rvl__reviewer-name">{name}</span>
          <div className="rvl__stars-date">
            <StarRating value={review.rating} readonly size="small" />
            <span className="rvl__date">{formatDate(review.created_at)}</span>
          </div>
        </div>
        <button
          className="rvl__report-btn"
          title="Report this review"
          onClick={() => alert('Review reported. Thank you for your feedback.')}
        >
          <IcFlag />
        </button>
      </div>

      <p className="rvl__text">{review.review_text}</p>

      {review.broker_reply && (
        <div className="rvl__reply">
          <div className="rvl__reply-header">
            <IcReply />
            <span>Broker's response</span>
            {review.broker_reply_at && (
              <span className="rvl__reply-date">{formatDate(review.broker_reply_at)}</span>
            )}
          </div>
          <p className="rvl__reply-text">{review.broker_reply}</p>
        </div>
      )}
    </div>
  );
}

export default function ReviewsList({ brokerId, refreshTrigger }) {
  const [reviews, setReviews] = useState([]);
  const [visible, setVisible] = useState(PAGE_SIZE);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    fetchBrokerReviews(brokerId).then((data) => {
      setReviews(data);
      setLoading(false);
    });
  }, [brokerId]);

  useEffect(() => { load(); }, [load, refreshTrigger]);

  if (loading) return <div className="rvl rvl--loading" />;
  if (reviews.length === 0) return null;

  const shown = reviews.slice(0, visible);
  const hasMore = visible < reviews.length;

  return (
    <div className="rvl">
      <div className="rvl__list">
        {shown.map((r) => <ReviewCard key={r.id} review={r} />)}
      </div>
      {hasMore && (
        <button className="rvl__show-more" onClick={() => setVisible((v) => v + PAGE_SIZE)}>
          Show more reviews ({reviews.length - visible} remaining)
        </button>
      )}
    </div>
  );
}
